export default __webpack_public_path__ + "static/media/BSLogoBlue.237d5d02.png";